/* eslint-disable no-shadow */

import Proxy from '@/proxies/CitaProxy';

export const getDefaultState = () => ({
  initCompleted: false,
  refUrl: null,
  partnerId: null,
  hasImage: false,
  partnerName: null,
  contentName: null,
  price: null,
  currency: null,
  chargingCycle: null,
  wholesalePartnerId: null,
  pageType: null,
  msisdnMinLength: null,
  msisdnMaxLength: null,
  msisdnCountryCode: null,
  msisdn: null,
  isAuthenticated: false,
  captcha: null,
  authSiteUrl: null,
  xtcContractId: null,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  INIT: 'INIT',
  SET_MSISDN: 'SET_MSISDN',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_PRICE: 'SET_PRICE',
  SET_CAPTCHA: 'SET_CAPTCHA',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
  },

  [types.INIT](state, response) {
    state.refUrl = response.refUrl;
    state.partnerId = response.partnerId;
    state.hasImage = response.hasImage;
    state.partnerName = response.partnerName;
    state.contentName = response.contentName;
    state.price = response.price;
    state.currency = response.currency;
    state.chargingCycle = response.chargingCycle;
    state.pageType = response.pageType;
    state.msisdnMinLength = response.msisdnMinLength;
    state.msisdnMaxLength = response.msisdnMaxLength;
    state.msisdnCountryCode = response.msisdnCountryCode;
    state.captcha = response.captcha;
    state.authSiteUrl = response.authSiteUrl;
    state.msisdn = response.msisdn;
    state.xtcContractId = response.xtcContractId;
    state.initCompleted = true;
  },

  [types.SET_MSISDN](state, value) {
    state.msisdn = value;
  },

  [types.SET_AUTHENTICATED](state) {
    state.isAuthenticated = true;
  },

  [types.SET_PRICE](state, value) {
    state.price = value;
  },

  [types.SET_CAPTCHA](state, value) {
    state.captcha = value;
  },
};

export const getters = {
  isPageTypeAnonymous: state => state.pageType === 'ANONYMOUS',
  isPageTypeNonAnonymousSimple: state => state.pageType === 'NON_ANONYMOUS_SIMPLE',
  isPageTypeNonAnonymousCaptcha: state => state.pageType === 'NON_ANONYMOUS_CAPTCHA',
  isPageTypeNonAnonymousCapOtp: state => state.pageType === 'NON_ANONYMOUS_CAP_OTP',
  isPageTypeNonAnonymousXtcOtp: state => state.pageType === 'NON_ANONYMOUS_XTC_OTP',
  isPageTypeAnonymousWithMsisdn: (state, getters) => getters.isPageTypeAnonymous && state.msisdn && !state.isAuthenticated,
  isPageTypeAnonymousAuthenticated: (state, getters) => getters.isPageTypeAnonymous && state.msisdn && state.isAuthenticated,
  getPageTypeWebtrekk: state => {
    switch (state.pageType) {
      case 'ANONYMOUS':
        return 'anonym';
      case 'NON_ANONYMOUS_CAPTCHA':
        return 'nicht-anonym-mit-captcha';
      case 'NON_ANONYMOUS_SIMPLE':
        return 'nicht-anonym-simple-ok';
      case 'NON_ANONYMOUS_XTC_OTP':
        return 'nicht-anonym-mit-xtcotp';
      case 'NON_ANONYMOUS_CAP_OTP':
        return 'nicht-anonym-mit-portal-otp';
      default:
        return 'unbekannt';
    }
  },
};

export const actions = {
  async init({ commit, dispatch }) {
    const response = await new Proxy().init();

    commit(types.INIT, response);

    dispatch('system/setWholesalePartnerId', response.wholesalePartnerId, { root: true });
    dispatch('system/setHasLogo', response.hasLogo, { root: true });
  },

  setAuthenticated({ commit }) {
    commit(types.SET_AUTHENTICATED);
  },

  setPrice({ commit }, value) {
    commit(types.SET_PRICE, value);
  },

  setCaptcha({ commit }, value) {
    commit(types.SET_CAPTCHA, value);
  },

  setMsisdn({ commit }, value) {
    commit(types.SET_MSISDN, value);
  },
};
